//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    inheritAttrs: false,
    model: {
        prop: 'modelValue',
        event: 'change',
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        fullwidth: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        // get the correct input select checked value since Chrome stores the checked value and re-populates it
        setTimeout(() => {
            const switchCheckbox = /** @type {HTMLInputElement} */ (this.$refs.switchCheckbox);
            this.$emit('change', switchCheckbox.checked);
        });
    },
    methods: {
        /** @param {UIEvent} e */
        change(e) {
            const target = /** @type {HTMLInputElement | null} */(e.target);
            if (!target) {
                return;
            }
            /**
             * @event change
             * @property {boolean} value
             */
            this.$emit('change', target.checked);
        },
    },
};
